import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { 
  Container, 
  Box, 
  TextField, 
  Button, 
  Typography, 
  Paper,IconButton, InputAdornment 
} from "@mui/material";
import Header from "../../components/Header";
import getCsrfToken from "../features/get_csrfToken";
import { Helmet } from "react-helmet";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default function SignupBus() {
  const [credidentials, setCredidentials] = useState({
    email: "",
    password: "",
    name: "",
    phoneNumber: ""
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredidentials({ ...credidentials, [e.target.id]: e.target.value });
  };
  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const validateForm = () => {
    const errors = {};
    if (!credidentials.email || !/\S+@\S+\.\S+/.test(credidentials.email)) {
      errors.email = "Veuillez entrer un email valide.";
    }
    if (!credidentials.password || credidentials.password.length < 8) {
      errors.password = "Le mot de passe doit contenir au moins 8 caractères.";
    }
    if (!credidentials.name) {
      errors.name = "Le nom de l'entreprise est requis.";
    }
    if (!credidentials.phoneNumber || !/^\+?\d{7,15}$/.test(credidentials.phoneNumber)) {
      errors.phoneNumber = "Veuillez entrer un numéro de téléphone valide (ex : +269...).";
    }

    return errors;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const csrfToken = await getCsrfToken(); // Récupérer le token CSRF
    const formErrors = validateForm();
    setErrors(formErrors);

    if (Object.keys(formErrors).length > 0) {
      return;
    }

    try {
      await axios.post("https://api.komorotel.com/api/business/register", {
        email: credidentials.email,
        name: credidentials.name,
        phoneNumber: credidentials.phoneNumber,
        password: credidentials.password
      }, {
        headers: {
          'Content-Type': 'application/json',
          'CSRF-Token': csrfToken // Ajouter le token CSRF

      },
        withCredentials:true
      });

      alert("Un e-mail vous a été envoyé. Veuillez le consulter pour finaliser l'inscription.");
      navigate("/business/login");
    } catch (err) {
      console.error(err);
      // Affiche le message d'erreur retourné par le backend ou un message générique
      const backendMsg = err.response?.data?.message || "Une erreur est survenue lors de l'enregistrement.";
      alert(backendMsg);
    }
  };

  return (
    <>
    <Helmet>
      <title>Inscription - Komorotel</title>
      <meta name="description" content="Créez un compte Komorotel pour réserver facilement votre hôtel aux Comores." />

      {/* Meta pour les réseaux sociaux */}
      <meta property="og:title" content="Inscription - Komorotel" />
      <meta property="og:description" content="Rejoignez Komorotel et commencez à réserver vos séjours aux Comores." />
      <meta property="og:image" content="https://komorotel.com/images/logo.png" />
      <meta property="og:url" content="https://komorotel.com/business/signup" />

      {/* Meta Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Inscription - Komorotel" />
      <meta name="twitter:description" content="Créez votre compte et accédez à vos réservations facilement." />
      <meta name="twitter:image" content="https://komorotel.com/images/logo.png" />
    </Helmet>

      <Header disabled={true} />

      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 4, mt: 8 }}>
          <Typography variant="h4" textAlign="center" gutterBottom>
            Créer un compte
          </Typography>
          <Typography variant="body1" textAlign="center" color="text.secondary" mb={3}>
            Veuillez entrer vos informations pour vous inscrire et accéder à nos services.
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              id="email"
              label="Adresse e-mail"
              type="email"
              fullWidth
              margin="normal"
              onChange={handleChange}
              error={!!errors.email}
              helperText={errors.email}
            />
            <TextField
                  fullWidth
                  label="Mot de passe"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={credidentials.password}
                  onChange={handleChange}
                  required
                  margin="normal"
                  variant="outlined"
                  error={!!errors.password}
                  helperText={errors.password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                          color="primary"
                          aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
            <TextField
              id="name"
              label="Nom de l'entreprise"
              type="text"
              fullWidth
              margin="normal"
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
            />
            <TextField
              id="phoneNumber"
              label="Numéro de téléphone"
              type="tel"
              inputMode="tel"
              fullWidth
              margin="normal"
              onChange={handleChange}
              error={!!errors.phoneNumber}
              helperText={errors.phoneNumber}
            />

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 3, py: 1.5 }}
            >
              Confirmer
            </Button>
          </Box>
          <Typography variant="body2" textAlign="center" color="text.secondary" mt={2}>
            Déjà un compte ?{" "}
            <Link to="/business/login" style={{ color: "#1976d2", textDecoration: "none" }}>
              Se connecter
            </Link>
          </Typography>
        </Paper>
      </Container>
    </>
  );
}
